/* eslint-disable react-hooks/exhaustive-deps */
import Button from '@base/Button/Button';
import useForm from '@base/Form/useForm';
import IconButton from '@base/IconButton/IconButton';
import Image from '@base/Image';
import useOfflineCentresStore from '@stores/offline-centres';

import { Spacings } from '@styles/index';
import { useEffect, useState } from 'react';
import fetch from '@api/fetchers';
import {
  Offline_Back_to_Step_1,
  Offline_Post_Payment_Completed,
  Offline_Post_Payment_Step_2_Landed
} from '@constants/segment';
import { segment } from '@actions/analytics';
import Link from '@base/Link/Link';
import { useSnackbar } from '@stores/snackbar';
import AddressDetails from './AddressDetails';
import { getPincodeData, getSubmitFormURL } from './apiHelper';
import FormHeading from './FormHeading';
import ParentDetails from './ParentDetails';
import { DEFAULT_COUNTRY } from '../constants';
import {
  BookAClassForm,
  CheckboxLabel,
  CheckboxWrapper,
  FormSectionHeading,
  PostPaymentFormContainer,
  StepWrapper,
  StyledCheckbox,
  StyledDivider,
  StyledPaper,
  StyledStepHeading,
  StyledSubSpan,
  StyledTerms,
  StyledTermsSpan
} from './styles';
import { stepNumbers } from './utils';

const PPFStep2 = ({ formState, updateStoreData }) => {
  const { open: showSnackbar } = useSnackbar();
  const { postPaymentForm, setPostPaymentFormState } = useOfflineCentresStore();
  const [isLocalAddressSame, setIsLocalAddressSame] = useState(
    postPaymentForm.isLocalAddressSame
  );

  const [isPincodeUpdated, setIsPincodeUpdated] = useState(false);
  const [isLocalPincodeUpdated, setIsLocalPincodeUpdated] = useState(false);

  const { registrar, isSubmitting, onFormSubmit } = useForm({
    data: formState
  });
  const { rollNumber } = formState;

  const { data, setData } = registrar;
  const { pincode, localPincode, city, state } = data;
  useEffect(() => {
    const {
      fullName,
      examCgpa,
      bloodGroup,
      parentFullName,
      parentPhoneNum,
      candidateIdType,
      candidateIdNumber,
      parentIdType,
      parentIdNumber
    } = formState;

    segment.track(Offline_Post_Payment_Step_2_Landed, {
      roll_number: rollNumber,
      name: fullName,
      last_class_atteneded: formState.class?.value || formState.class,
      cgpa: examCgpa,
      blood_group: bloodGroup?.value || bloodGroup,
      candidateIdType: candidateIdType?.value || candidateIdType,
      parentIdType: parentIdType?.value || parentIdType,
      photo_uploaded: 'yes',
      id_uploaded: 'yes',
      parent_name: parentFullName,
      parent_number: parentPhoneNum,
      parent_id_number: parentIdNumber,
      candidate_id_number: candidateIdNumber
    });
    window?.scrollTo(0, 0);
  }, []);
  const onSubmit = async (formData) => {
    let modifiedData = { ...formState, ...formData };

    modifiedData = {
      ...modifiedData,
      candidateId: {
        name: modifiedData.candidateId?.name,
        public_url: modifiedData.candidateId?.public_url
      },
      candidatePhoto: {
        name: modifiedData.candidatePhoto?.name,
        public_url: modifiedData.candidatePhoto?.public_url
      },
      candidateMarksheet: {
        name: modifiedData.candidateMarksheet?.name,
        public_url: modifiedData.candidateMarksheet?.public_url
      },
      parentId: {
        name: modifiedData.parentId?.name,
        public_url: modifiedData.parentId?.public_url
      },
      bloodGroup: modifiedData.bloodGroup?.value,
      candidateIdType: modifiedData.candidateIdType?.value,
      parentIdType: modifiedData.parentIdType?.value,
      class: modifiedData.class?.value,
      isFormSubmitted: true
    };

    if (isLocalAddressSame) {
      modifiedData = {
        ...modifiedData,
        localAddressLine1: modifiedData.addressLine1,
        localAddressLine2: modifiedData.addressLine2,
        localCity: modifiedData.city,
        localPincode: modifiedData.pincode,
        localState: modifiedData.state
      };
    }

    const body = {
      'form-type': 1,
      'form-details': { ...modifiedData }
    };

    fetch(getSubmitFormURL(), {
      useCamelCase: false,
      requestType: 'POST',
      body
    })
      .then(async (res) => {
        if (res?.error) {
          const errorResponse = res?.error;
          showSnackbar({
            message:
              errorResponse?.message ||
              'Something went wrong. Please try again.',
            type: 'error'
          });
        } else {
          setPostPaymentFormState({
            isFormSubmitted: true
          });
        }
      })
      .catch(() => {
        showSnackbar({
          message: 'Something went wrong. Please try again.',
          type: 'error'
        });
      });

    segment.track(Offline_Post_Payment_Completed, {
      pincode_local: localPincode,
      City: city,
      State: state,
      Pincode_permanent: pincode
    });
  };
  const handleOnSubmit = onFormSubmit(onSubmit);

  const updatePincodeData = (updatedObj) => {
    setPostPaymentFormState({
      ...updatedObj
    });
  };

  useEffect(() => {
    if (pincode && isPincodeUpdated) {
      const timeoutId = setTimeout(() => {
        const fetchFun = () => {
          if (pincode.length === 6) {
            getPincodeData(pincode).then((res) => {
              if (res.errorCode) {
                setData('city', '');
                setData('state', '');
                updatePincodeData({ city: '', state: '' });
              } else {
                setData('city', res.city);
                setData('state', res.state);
                updatePincodeData({ city: res.city, state: res.state });
              }
            });
          }
        };
        fetchFun();
      }, 500);
      return () => clearTimeout(timeoutId);
    }
  }, [pincode]);

  useEffect(() => {
    if (localPincode && isLocalPincodeUpdated) {
      const timeoutId = setTimeout(() => {
        const fetchFun = () => {
          if (localPincode.length === 6) {
            getPincodeData(localPincode).then((res) => {
              if (res.errorCode) {
                setData('localCity', '');
                setData('localState', '');
                updatePincodeData({ localCity: '', localState: '' });
              } else {
                setData('localCity', res.city);
                setData('localState', res.state);
                updatePincodeData({
                  localCity: res.city,
                  localState: res.state
                });
              }
            });
          }
        };
        fetchFun();
      }, 500);
      return () => clearTimeout(timeoutId);
    }
  }, [localPincode]);

  const handleBackButton = () => {
    setPostPaymentFormState({
      stepNum: stepNumbers.ONE
    });
    segment.track(Offline_Back_to_Step_1, {
      roll_number: rollNumber
    });
  };

  const updateLocalAddressState = () => {
    if (!isLocalAddressSame) {
      setPostPaymentFormState({
        localAddressLine1: postPaymentForm.addressLine1,
        localAddressLine2: postPaymentForm.addressLine2,
        localPincode: postPaymentForm.pincode,
        localCity: postPaymentForm.city,
        localState: postPaymentForm.state,
        isLocalAddressSame: true
      });
    } else {
      setPostPaymentFormState({
        isLocalAddressSame: false
      });
    }
    setIsLocalAddressSame((prevValue) => !prevValue);
  };

  return (
    <PostPaymentFormContainer>
      <StyledPaper>
        <BookAClassForm $display>
          <FormHeading rollNumber={rollNumber} />
          <StyledDivider />
          <StepWrapper>
            <IconButton onClick={handleBackButton}>
              <Image
                src="offline-centres/postpayment/back-arrow.svg"
                width={Spacings.SPACING_10B}
                height={Spacings.SPACING_10B}
                alt="back-btn"
              />
            </IconButton>
            <StyledStepHeading style={{ marginLeft: `${Spacings.SPACING_4B}` }}>
              Step 2 of 2
            </StyledStepHeading>
          </StepWrapper>
          <ParentDetails
            registrar={registrar}
            country={DEFAULT_COUNTRY}
            updateStoreData={updateStoreData}
          />
          <FormSectionHeading>Permanent address</FormSectionHeading>
          <AddressDetails
            registrar={registrar}
            localAddress={false}
            updateStoreData={updateStoreData}
            setData={setData}
            setIsPincodeUpdated={setIsPincodeUpdated}
            setIsLocalPincodeUpdated={setIsLocalPincodeUpdated}
          />
          <FormSectionHeading>
            Local address <StyledSubSpan>(Optional)</StyledSubSpan>
          </FormSectionHeading>
          <CheckboxWrapper>
            <StyledCheckbox
              checked={isLocalAddressSame}
              value={isLocalAddressSame}
              onChange={updateLocalAddressState}
              color="var(--color-text-primary)"
            />
            <CheckboxLabel>Same as permanent address</CheckboxLabel>
          </CheckboxWrapper>
          <AddressDetails
            registrar={registrar}
            isLocalAddressSame={isLocalAddressSame}
            localAddress
            updateStoreData={updateStoreData}
            setData={setData}
            setIsPincodeUpdated={setIsPincodeUpdated}
            setIsLocalPincodeUpdated={setIsLocalPincodeUpdated}
          />
          <StyledTerms>
            By continuing, you agree to{' '}
            <Link href="/terms" anchorStyle={StyledTermsSpan}>
              Unacademy’s terms
            </Link>
          </StyledTerms>
          <Button
            onClick={handleOnSubmit}
            width="100%"
            variant={isSubmitting ? 'disabled' : 'filled'}
            label="Submit"
            color="black"
          />
        </BookAClassForm>
      </StyledPaper>
    </PostPaymentFormContainer>
  );
};

export default PPFStep2;
